'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.checkCookie = exports.validateUser = exports.closeProductModal = exports.openProductModal = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _handlers = require('components/Overlay/handlers.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var openProductModal = exports.openProductModal = function openProductModal($this) {
	var modalIndex = parseInt($this.attr('data-index'));
	var imgSrc = window.imageArray[modalIndex];
	$(_Dom2.default.intModal).addClass('is-active');
	$(_Dom2.default.intModalImg).attr('src', imgSrc);
	(0, _handlers.showOverlay)();
};

var closeProductModal = exports.closeProductModal = function closeProductModal($this) {
	$(_Dom2.default.intModal).removeClass('is-active');
};

var validateUser = exports.validateUser = function validateUser($form) {
	var inputVal = $(_Dom2.default.intPasswordInput).val();
	if (inputVal === window.internationalLoginPassword) {
		sessionStorage.setItem('intValidated', true);
		return window.location.href = '/pages/international-english';
	}

	return $(_Dom2.default.intFormError).addClass('is-active');
};

var checkCookie = exports.checkCookie = function checkCookie(cookie) {
	if (window.sessionStorage.getItem(cookie) === 'true') {
		$(_Dom2.default.intLanding).addClass('is-visible');
	} else {
		window.location.href = '/pages/international-login';
	}
};